import { Box, Paper, Typography } from '@mui/material';
import React from 'react';
import Layout from '../components/Layout';
import LeadCaptureWidget from '../components/LeadCaptureWidget';

const LeadsFormDemoPage = () => {
  const apiBaseUrl = process.env.GATSBY_API_BASE || 'http://127.0.0.1:5000';
  const publicKey = typeof window !== 'undefined' ? (new URLSearchParams(window.location.search).get('pk') || '') : '';

  return (
    <Layout>
      <Box sx={{ p: 3 }}>
        <Typography variant="h5" sx={{ mb: 2, color: 'white' }}>Демо формы захвата лидов</Typography>
        <Paper sx={{ p: 2, background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.15)' }}>
          <Typography variant="body2" sx={{ mb: 2, color: 'rgba(255,255,255,0.85)' }}>
            Передайте публичный ключ в URL как <code>?pk=YOUR_PUBLIC_KEY</code>. Базовый URL API берётся из переменной окружения <code>GATSBY_API_BASE</code>, иначе <code>http://127.0.0.1:5000</code>.
          </Typography>
          <LeadCaptureWidget publicKey={publicKey} apiBaseUrl={apiBaseUrl} />
        </Paper>
      </Box>
    </Layout>
  );
};

export default LeadsFormDemoPage;

